import { LoadablePaint } from '@confluence/loadable';

export const GoToHomeLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GoToHome" */ '../src/GoToHome.tsx')).GoToHome,
});
